import { AppFooter } from "../../../shared/components/AppFooter";
import { ABOUT_URL } from "../../../shared/config/runtimeConfig";
import { TranslationKey } from "../../../shared/i18n/i18n";

type AdminFooterProps = {
  t: (key: TranslationKey) => string;
};

export const AdminFooter = ({ t }: AdminFooterProps) => {
  return (
    <AppFooter>
      <a
        className="app-footer-link"
        href={ABOUT_URL}
        rel="noreferrer"
        target="_blank"
      >
        {t("footer.about")}
      </a>
    </AppFooter>
  );
};
